import { render, staticRenderFns } from "./Chart3.vue?vue&type=template&id=2d6afefc&scoped=true"
import script from "./Chart3.vue?vue&type=script&lang=js"
export * from "./Chart3.vue?vue&type=script&lang=js"
import style0 from "./Chart3.vue?vue&type=style&index=0&id=2d6afefc&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d6afefc",
  null
  
)

export default component.exports